<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <div class="hm-heading">
        <span class="hm-heading__id">House Accounts</span>
      </div>
      <router-link
        :to="{ name: 'hotel-management-house-accounts-detail', params: { id: card.id } }"
        v-for="card in accounts_list"
        :key="card.id"
        class="ha-card"
      >
        <span class="ha-card__name">{{ card.account_name }}</span>
        <div class="ha-card__balance">
          Balance:
          <HMBalance :balance="card.balance"/>
        </div>
      </router-link>
    </template>
  </div>
</template>

<script>
import { getHotelManagementHouseAccountsV2 } from '@/http'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'

export default {
  name: 'HotelManagementHouseAccountsList',
  components: {HMBalance},
  data() {
    return {
      page_loaded: false,
      accounts_list: [],
    }
  },
  created() {
    getHotelManagementHouseAccountsV2()
      .then((response) => {
        this.accounts_list = response.data
        this.page_loaded = true
      })
  }
}
</script>

<style>
.hm-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
}

.hm-heading__id {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.1;
}

.ha-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  max-width: 474px;
  margin-bottom: 20px;
  padding: 23px 30px;
  border-radius: 16px;
  border: 1px solid #e9e9e9;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
  transition: border-color 0.3s;

  @media (hover: hover) {
    &:hover,
    &:focus-visible {
      border-color: #a3a3a3;
    }
  }
}

.ha-card__name {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.ha-card__balance {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}
</style>